import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Box, Typography } from '@heycater/design-system';

import { embeddedAssetOptions } from 'hub/helpers/contentful';
import SearchLandingPageImage from 'static_pages/marketing_pages/components/SearchLandingPageImage';

function SearchLandingPageSection({ title, image, body }) {
  const formattedBody =
    body &&
    documentToReactComponents(
      body,
      embeddedAssetOptions(body.links?.assets?.block)
    );

  return (
    <React.Fragment>
      <Box textAlign="center">
        <Typography variant="h4" mt={4} mb={4}>
          {title}
        </Typography>
      </Box>

      {image && <SearchLandingPageImage {...image} />}
      {body && <Box>{formattedBody}</Box>}
    </React.Fragment>
  );
}

export default SearchLandingPageSection;
